import { getTime } from 'date-fns';

export default (date) => {
  const timestamp = getTime(new Date(date));

  return (timestamp / 1000).toFixed(6).toString();
};
